var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['spinner', _vm.mask ? 'mask' : '']},[_c('PulseLoader',{attrs:{"loading":"","color":"#9e9e9e"}}),(Boolean(_vm.message))?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }